import { useL10n } from "@ews/react-localization-context";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsCheckboxTextInput from "../../../Settings/SettingsComponents/SettingsCheckboxTextInput/SettingsCheckboxTextInput";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";

const AlarmTransmission: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();

    return <>
        <SettingsTextInput
            text={t("TRVB_TO_RECEIVING_STATION_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_TO_RECEIVING_STATION_LABEL")} />}
            value={specification.alarmTransmission?.toTheAlarmreceivingCenter}
            onBlur={({ value }) =>
            {
                if (specification.alarmTransmission?.toTheAlarmreceivingCenter === value) return;
                if (systemId && specification.alarmTransmission) {
                    modifySystemSpecification(systemId, {
                        ...specification,
                        alarmTransmission: {
                            ...specification.alarmTransmission,
                            toTheAlarmreceivingCenter: value
                        },
                    });
                }
            }
            } />
        <SettingsLabel text={"TRVB_AUTOMATIC_LABEL"} labelPosition={'floating'} lines={'none'} />
        <SettingsCheckbox
            text={t("TRVB_CLASS_1_EN54_21_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_CLASS_1_EN54_21_LABEL")} />}
            checked={specification.alarmTransmission?.automaticClass1 || false}
            onChange={(checked) =>
            {
                if (specification.alarmTransmission?.automaticClass1 === checked) return;
                if (systemId && specification.alarmTransmission) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        alarmTransmission: {
                            ...specification.alarmTransmission,
                            automaticClass1: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_CLASS_2_EN54_21_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_CLASS_1_EN54_21_LABEL")} />}
            checked={specification.alarmTransmission?.automaticClass2 || false}
            onChange={(checked) =>
            {
                if (specification.alarmTransmission?.automaticClass2 === checked) return;
                if (systemId && specification.alarmTransmission) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        alarmTransmission: {
                            ...specification.alarmTransmission,
                            automaticClass2: checked
                        },
                    });
                }
            }} />
        <SettingsLabel text={"TRVB_MANUAL_LABEL"} labelPosition={'floating'} lines={'none'} />
        <SettingsCheckboxTextInput text={t("TRVB_BY_PERSON_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_BY_PERSON_LABEL")} />} value={specification.alarmTransmission?.manualByPerson} disabled={true} onBlur={({ value }) =>
            {
                if (specification.alarmTransmission?.manualByPerson === value) return;
                if (systemId && specification.alarmTransmission) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        alarmTransmission: {
                            ...specification.alarmTransmission,
                            manualByPerson: value
                        },
                    });
                }
            }} />
        <SettingsCheckboxTextInput text={t("TRVB_OTHER_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_OTHER_LABEL")} />} value={specification.alarmTransmission?.manualOther} disabled={true} onBlur={({ value }) =>
            {
                if (specification.alarmTransmission?.manualOther === value) return;
                if (systemId && specification.alarmTransmission) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        alarmTransmission: {
                            ...specification.alarmTransmission,
                            manualOther: value
                        },
                    });
                }
            }} />
    </>;
};

export default AlarmTransmission;
